<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div>
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('invoices.invoices_issuing.step4.cantidad_min_max') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.min') }}</label>
                      <el-form-item prop="taxRateMin">
                        <el-input clearable class="w-full" v-model="form.taxRateMin.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.max') }}</label>
                      <el-form-item prop="taxRateMax">
                        <el-input clearable class="w-full" v-model="form.taxRateMax.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.name') }}</label>
              <el-form-item prop="name">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.name.value"
                  maxlength="50"
                />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
// import _ from 'lodash'
import { i18n } from '@/i18n'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'

// import { mapGetters } from 'vuex'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'invoicesIssuing/3',
      isOpen: this.panelOpen,
      form: {
        name: { label: i18n.t('app.name'), value: '' },
        taxRateMin: { label: i18n.t('app.min'), value: '' },
        taxRateMax: { label: i18n.t('app.max'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  mounted: async function () {
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposPais: function () {
      return this.$store.getters['config/PAISES']
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.name.value = _temp.name !== undefined && _temp.name ? _temp.name.value : ''
        this.form.taxRateMin.value = _temp.taxRateMin !== undefined && _temp.taxRateMin ? _temp.taxRateMin.value : ''
        this.form.taxRateMax.value = _temp.taxRateMax !== undefined && _temp.taxRateMax ? _temp.taxRateMax.value : ''
      }
    },
    watchFormHandler: function ({ send_alerts, estado, certAsociado }) {
      if (send_alerts !== undefined && send_alerts.value) {
        this.form.send_alerts.value = !!send_alerts.value
      }
      if (estado !== undefined && estado.value) {
        this.form.estado.value = !!estado.value
      }
      if (certAsociado !== undefined && certAsociado.value) {
        this.form.certAsociado.value = !!certAsociado.value
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        name: { label: i18n.t('app.name'), value: '' },
        taxRateMin: { label: i18n.t('app.min'), value: '' },
        taxRateMax: { label: i18n.t('app.max'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    }
  }
}
</script>

<style lang="scss" scoped></style>
